import {getAPIbaseURL} from "@/api/config/init";

export function openDownloadFile(tipo, filename, name, open = true) {
    const url = `${getAPIbaseURL()}/download.php?tipo=${tipo}&file=${filename}&name=${name}&time=1100`;
    if (open) {
        window.open(url, '_blank');
    }
    return url;
}
